<template>
  <div class="cafe">
    <v-container fluid style="padding-top: 70px;">
        <v-img style="height:400px" src="../assets/cafe/cappuccino.jpg">
            <v-row align="end" class="lightbox white--text pa-2 fill-height">
                <v-col>
                    <v-container>
                        <div class="display-2 font-weight-bold">Café</div>
                    </v-container>
                </v-col>
            </v-row>
        </v-img>
    </v-container>
    <Card :texts="texts.coffe" :cards="coffe" />
    <Card :texts="texts.postres" :cards="postres" />
  </div>
</template>
<script>
import Card from '../components/Card';

export default {
  name: 'Cafe',
  components:{
    Card
  },
  data: () => ({
    coffe: [
        {
          id: 1,
          img: require("../assets/cafe/cafe-expresso.jpg"),
          title: 'Expresso',
          text: 'Expresso',
        },
        {
          id: 2,
          img: require("../assets/cafe/cafe-leche.jpg"),
          title: 'Cafe con leche',
          text: 'Cafe con leche',
        },
        {
          id: 3,
          img: require("../assets/cafe/cafe-bou.jpeg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 4,
          img: require("../assets/cafe/cafe-leche2.jpeg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 5,
          img: require("../assets/cafe/tasas.jpeg"),
          title: 'Cafe',
          text: 'Cafe.',
        },
        {
          id: 6,
          img: require("../assets/cafe/cafe-manduca.jpeg"),
          title: 'Cappuccino',
          text: 'Cappuccino.',
        },
        {
          id: 7,
          img: require("../assets/cafe/cafe-dulces.jpeg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 8,
          img: require("../assets/cafe/cafe-dulces2.jpeg"),
          title: 'Cafe',
          text: 'Cafe.',
        },
        {
          id: 9,
          img: require("../assets/cafe/cafe-cappuccino.jpeg"),
          title: 'Cappuccino',
          text: 'Cappuccino.',
        }
    ],
    postres: [
        {
          id: 1,
          img: require("../assets/imageGalery2.jpg"),
          title: 'Expresso',
          text: 'Expresso',
        },
        {
          id: 2,
          img: require("../assets/imageGalery6.jpg"),
          title: 'Cafe con leche',
          text: 'Cafe con leche',
        },
        {
          id: 3,
          img: require("../assets/imageGalery7.jpg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 4,
          img: require("../assets/imageGalery8.jpeg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 5,
          img: require("../assets/imageGalery9.jpeg"),
          title: 'Cafe',
          text: 'Cafe.',
        },
        {
          id: 6,
          img: require("../assets/imageGalery10.jpg"),
          title: 'Cappuccino',
          text: 'Cappuccino.',
        },
        {
          id: 7,
          img: require("../assets/postres/medialuna-dulce.jpeg"),
          title: 'Cafe',
          text: 'Cafe',
        },
        {
          id: 8,
          img: require("../assets/postres/medialuna-dulce2.jpeg"),
          title: 'Cafe',
          text: 'Cafe.',
        },
        {
          id: 9,
          img: require("../assets/postres/medialuna-dulce3.jpeg"),
          title: 'Cappuccino',
          text: 'Cappuccino.',
        }
    ],
    texts: {
      coffe: {
        title: "Todos nuestros cafes",
        subtitle: "Trabajamos con BOU Café, quien desde 1957 se dedica a la elaboración y comercialización de Café de máxima calidad para el sector HORECA (Hostelería, Restauración y Catering)."
      },
      postres: {
        title: "Todos nuestros Postres",
        subtitle: "Trabajamos con la Pasteleria La Montevideana Manacor, una pasteleria tipica del rio de la plata, con sus postres y tartas ..."
      }
    }
  }),
}
</script>
